import { render, staticRenderFns } from "./ImagePrior.vue?vue&type=template&id=3d893102&"
import script from "./ImagePrior.vue?vue&type=script&lang=js&"
export * from "./ImagePrior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports